// extracted by mini-css-extract-plugin
export default {"root":"EditListingDescriptionForm_root__qlLhN","error":"EditListingDescriptionForm_error__pVHxX","submitButton":"EditListingDescriptionForm_submitButton__1u5xT"};